import {useEffect, useState} from 'react';

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";
import MDAvatar from "components/MDAvatar";

import {getPhotoSource} from "api/requests"

import {readStream} from "readStream/readStream"

import { useTokenContext } from "App";
import { timeConverter } from 'timeConverter/timeConverter';

function RetailerAvatar({ nickname, photoId, level, balance, actions, noGutter, onViewClick, staticPhoto }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [myStorage, setMyStorage] = useState({})
  const {token} = useTokenContext();
  
  const [nrPhotosDownloaded, setNrPhotosDownloaded] = useState(0)

  useEffect(() => {
    if(photoId){
      if(localStorage.getItem(photoId) === null){
        getPhotoSource(photoId, token)
        .then(response => {
          const reader = response.body.getReader();
          readStream(reader)
          .then(base64Response => {
            localStorage.setItem(photoId, base64Response)
            setNrPhotosDownloaded(nr => nr+1)
          })
          
        })
      }
    }
  }, [photoId]);

  useEffect(() => {
    setMyStorage(localStorage)
  }, [nrPhotosDownloaded])

  return (
    <>
    <MDBox
      component="li"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      bgColor={darkMode ? "transparent" : "grey-100"}
      borderRadius="lg"
      p={3}
      mb={noGutter ? 0 : 1}
      mt={2}
    >
      <MDBox width="100%" display="flex" flexDirection="column">
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexDirection={{ xs: "column", sm: "row" }}
          mb={2}
        >
          <MDBox 
            display="flex"
            flex={1}
            justifyContent="left"
            alignItems="center"
            >
            {staticPhoto ? <MDAvatar src={photoId} alt={nickname} size="lg"/>
            :
            <MDAvatar src={'data:image/png;base64,'+myStorage[photoId]} alt={nickname} size="lg"/>
            } 
            <MDBox>
              <MDTypography variant="button" fontWeight="medium" textTransform="capitalize" ml={2}>
                {nickname}
              </MDTypography>
              <MDBox ml={2} lineHeight={0}>
                <MDTypography variant="button" color="text">
                  Level:&nbsp;&nbsp;&nbsp;
                  <MDTypography variant="button" fontWeight="medium" textTransform="capitalize">
                    {level}
                  </MDTypography>
                </MDTypography>
              </MDBox>
            </MDBox>
          </MDBox>
          <MDBox flex={5} display="flex" alignItems="center" justifyContent="space-between" mt={2.5}>
          <MDBox lineHeight={2} sx={{justifyContent:"center", alignItems:"center"}}>
            <MDTypography display="block" variant="caption" fontWeight="medium" color="text">
                {"Balance"}
              </MDTypography>
            <MDTypography variant="button" fontWeight="medium" >
              {balance}
            </MDTypography>
          </MDBox>
          {actions.map((action) => (
           <MDBox lineHeight={2} sx={{justifyContent:"center", alignItems:"center"}}>
              <MDTypography display="block" variant="caption" fontWeight="medium" color="text" >
              {action['action_name']}
              </MDTypography>
              <MDTypography variant="caption" fontWeight="medium" mb={1} lineHeight={0}>
                {action['action_summary']}
              </MDTypography>
            </MDBox>
          ))}
          
          <MDBox display="flex" alignItems="center" mt={{ xs: 2, sm: 0 }} ml={{ xs: -1.5, sm: 0 }}>
            <MDButton variant="text" color={darkMode ? "white" : "dark"} onClick={onViewClick}>
              <Icon>visibility</Icon>&nbsp;&nbsp;view
            </MDButton>
          </MDBox>
         </MDBox>
        </MDBox>
      </MDBox>
    </MDBox>
    </>
  );
}

// Setting default values for the props of Bill
RetailerAvatar.defaultProps = {
  noGutter: false,
};


export default RetailerAvatar;
